module.exports = __webpack_public_path__ + "img/ntk_nav_add_g.a4e3523e.svg";